import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { GroupServiceProductService } from '../../services/group-service-product.service';

@Component({
  selector: 'app-edit-group-service-product',
  templateUrl: './edit-group-service-product.component.html',
  styleUrls: ['./edit-group-service-product.component.css']
})
export class EditGroupServiceProductComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];
listSale: { label: string; value: number }[]=[
  { label: 'Dịch vụ bưu chính', value: 1 },
  { label: 'Tài chính bưu chính', value: 2 },
  { label: 'Phân phối truyền thông', value: 3 },
]
isDisable: any;

constructor(
  protected _service: GroupServiceProductService,
  protected _injector: Injector
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    businessSectorCode: new UntypedFormControl('', [Validators.required]),
    serviceProductGroupCode: new UntypedFormControl('', [Validators.required]),
    serviceProductGroupName: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl(''),
  });
}

ngOnInit() {}

onShowPopup(model: any) {
  this.isDisable = model.isDisable;
  this.validationSummary.resetErrorMessages();
  this.resetForm();

  if (model.id > 0) {
    this._service.getServiceProductDetail(model.id).then(
      (rs) => {
        this.itemDetail = rs.data;
      },
      (error) => {
        this._notifierService.showWarning(
          this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
        );
      }
    );
  }
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }

  this.onUpdate();
}

onUpdate() {
  this._service.update(this.itemDetail.id, this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showUpdateDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showUpdateDataFailed();
      this.submitting = false;
    }
  );
}
}
